export default __webpack_public_path__ + "static/media/discuss.994baf0d.svg";